module.exports = __webpack_public_path__ + "media/night/362-782f8b30.svg";